(function ($) {

    // ── Popover ARIA + focus management ─────────────────────────────────
    // Native HTML5 popover toggles visibility but doesn't sync aria-expanded
    // on triggers or move focus into the popover when it opens. We do both.

    function syncAriaExpanded(popoverId, isOpen) {

        $('[popovertarget="' + popoverId + '"]').attr('aria-expanded', isOpen ? 'true' : 'false');

    }

    // preventScroll: jQuery's .focus() scrolls the focused element into view, and
    // with a sticky header that took the reader back to the top of the page every
    // time a menu opened. The menus are pinned to the screen, so nothing needs to
    // scroll for the first link to be seen.
    function focusFirstInside($popover) {

        var first = $popover
            .find('button, a, [tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .get(0);

        if (first) {

            first.focus({ preventScroll: true });

        }

    }

    // Initial state — every trigger is collapsed on load.
    $('[popovertarget]').attr('aria-expanded', 'false');

    // Wire toggle on every popover that has an id.
    // Modern browsers fire `beforetoggle` and `toggle` with newState='open'|'closed'.
    // We record the opener on beforetoggle so we can restore focus to it on close —
    // native restoration is unreliable when the close trigger is a button INSIDE the
    // popover (e.g. a sub-panel back button using popovertarget to self-close), because
    // that button hides with the popover and focus falls to <body>.
    $('[popover][id]').each(function () {

        var $popover  = $(this),
            popoverId = $popover.attr('id'),
            $opener   = null;

        $popover.on('beforetoggle', function (event) {

            if (event.originalEvent && event.originalEvent.newState === 'open') {

                $opener = $(document.activeElement);

            }

        });

        $popover.on('toggle', function (event) {

            var isOpen = event.originalEvent && event.originalEvent.newState === 'open';

            syncAriaExpanded(popoverId, isOpen);

            if (isOpen) {

                focusFirstInside($popover);

            } else if ($opener && $opener.length && $opener.is(':visible')) {

                // Defer one tick so any browser-native focus fallback (which can
                // set focus to <body> when the popover hides while focus is inside)
                // settles first; then we explicitly restore to the opener.
                var opener = $opener;
                setTimeout(function () { opener.focus(); }, 0);

            }

        });

    });

    // ── Desktop menu drawer behaviour ───────────────────────────────────

    // Mark the desktop popover and its close button active when the open
    // animation finishes. Hooks CSS transitions in.
    $('#desktop_menu').on('animationend', function () {

        $(this).addClass('is-active');
        $('.site-nav__close').addClass('is-active');

    });

    // Reset state when the desktop popover closes.
    $('#desktop_menu').on('toggle', function (event) {

        if (event.originalEvent && event.originalEvent.newState === 'closed') {

            $('#desktop_menu, .desktop-nav__menu__panel, .desktop-nav__menu__drawer, .site-nav__close')
                .removeClass('is-active');

            $('.desktop-nav').css('padding-right', '170px');

        }

    });

    // Top-level nav item with a sub-panel — show its panel inside the open menu.
    // Scope to [data-panel] so anchors for no-sub-menu items don't run the
    // panel-switching logic (which used to clear the currently-open panel one frame
    // before native navigation, causing a visible flicker on the way out).
    //
    // This selector matches two copies of the same trigger: the one in the site
    // head (opens the popover — never carries data-url, never gets is-active) and
    // the one inside .desktop-nav__inner (the header row repeated at the top of
    // the open popover). That second copy DID carry data-url and DID receive
    // is-active, so clicking it again used to navigate via window.location.href.
    // Nothing on screen advertised that a second click on an already-open item
    // behaved differently from the first, so the affordance is now the explicit
    // "All <title>" link instead — the data-url attribute on the
    // .desktop-nav__inner copy was removed alongside this handler's old branch.
    $('.site-nav__menu__item[data-panel]').on('click', function () {

        var elem  = $(this),
            panel = '#' + elem.data('panel');

        $('.site-nav__menu__item[data-panel]').removeClass('is-active');
        $('.desktop-nav__inner .site-nav__menu__item[data-panel="' + elem.data('panel') + '"]').addClass('is-active');
        $('.desktop-nav__menu__panel').removeClass('is-active');
        $(panel).addClass('is-active');

    });

    // Second-level nav item — slide its drawer in beside the open menu.
    //
    // The staggered contents are addressed with find() rather than children():
    // the items sit inside .desktop-nav__drawer-items (the grid that flows them
    // down before across), so they are grandchildren of the drawer, and only the
    // "All <title>" link is still a direct child.
    //
    // Selected by [data-nav-stagger] rather than a hand-listed class selector —
    // header.php stamps the attribute on everything that should stagger, so a
    // future third drawer-content type stagger-fades by carrying the attribute
    // rather than by this shared file also being updated to know its class.
    var DRAWER_CONTENTS = '[data-nav-stagger]';

    $('.desktop-nav__menu__item').on('click', function () {

        var elem   = $(this),
            drawer = $('#' + elem.data('drawer'));

        if (drawer.length && !drawer.hasClass('is-active')) {

            $('.desktop-nav__menu__drawer').removeClass('is-active').find(DRAWER_CONTENTS).removeClass('is-active');

            var drawerWidth = drawer.outerWidth() + 60;

            $('.desktop-nav').animate({ paddingRight: drawerWidth + 'px' }, 300, function () {

                drawer.addClass('is-active').find(DRAWER_CONTENTS).addClass('is-active');

            });

        }

    });

    // Align the desktop popover's left edge to the inner header wrapper.
    // Defensive — Phase D may flatten the wrapper away; fall back to the
    // site-head bounds if the inner wrapper is missing.
    function alignDesktopNav() {

        var $anchor = $('.site-head__main__inner');

        if (!$anchor.length) {

            $anchor = $('.site-head');

        }

        if ($anchor.length) {

            $('.desktop-nav').css('left', $anchor.offset().left + 'px');

        }

    }

    alignDesktopNav();

    $(window).on('resize.menuControl', debounce(alignDesktopNav, 150));

}(jQuery));
